import { render, staticRenderFns } from "./azure-disk.vue?vue&type=template&id=d9c1972e&scoped=true&"
import script from "./azure-disk.vue?vue&type=script&lang=js&"
export * from "./azure-disk.vue?vue&type=script&lang=js&"
import style0 from "./azure-disk.vue?vue&type=style&index=0&id=d9c1972e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c1972e",
  null
  
)

export default component.exports